import { render, staticRenderFns } from "./OrganisationsPage.vue?vue&type=template&id=18d58308&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d58308')) {
      api.createRecord('18d58308', component.options)
    } else {
      api.reload('18d58308', component.options)
    }
    module.hot.accept("./OrganisationsPage.vue?vue&type=template&id=18d58308&", function () {
      api.rerender('18d58308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationsPage.vue"
export default component.exports